<div class="form">
  <div class="dx-fieldset">
    <!-- Tipo editing -->
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
        Tipo di editing
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-select-box
          [showClearButton]="true"
          #selectBoxTipoEditing
          [items]="gridConfEditingTypes"
          [(value)]="editType"
          >
          ></dx-select-box
          >
        </div>
      </div>

      @if (gridConf.editType && gridConf.editType === 'external page') {
        <div
          class="dx-field"
          >
          <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
            Pagina di dettaglio
          </div>
          <div class="dx-field-value" style="width: 30%">
            <dx-text-box [(value)]="gridConf.externalPage"></dx-text-box>
          </div>
        </div>
      }
      @if (
        gridConf.editType &&
        gridConf.editType != 'external page' &&
        gridConf.editType != 'navigazione'
        ) {
        <div
          >
          <!-- Riorinamento righe -->
          @if (gridConf.updatingController === 'kvpi') {
            <div class="dx-field">
              <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
                Abilita riordinamento delle righe
              </div>
              <div class="dx-field-value" style="width: 30%">
                <dx-switch [(value)]="gridConf.allowRowReordering"></dx-switch>
              </div>
            </div>
          }
          <!-- Permessi Crud -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              La griglia consente inserimento
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-switch [(value)]="gridConf.allowAdding"></dx-switch>
            </div>
          </div>
          @if (gridConf.allowAdding) {
            <div class="dx-field">
              <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
                Controller custom per inserimento
              </div>
              <div class="dx-field-value" style="width: 30%">
                <dx-text-box [(value)]="gridConf.addingController"></dx-text-box>
              </div>
            </div>
          }
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              La griglia consente la modifica
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-switch [(value)]="gridConf.allowUpdating"></dx-switch>
            </div>
          </div>
          @if (gridConf.allowUpdating) {
            <div class="dx-field">
              <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
                Controller custom per la modifica
              </div>
              <div class="dx-field-value" style="width: 30%">
                <dx-text-box [(value)]="gridConf.updatingController"></dx-text-box>
              </div>
            </div>
          }
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              La griglia consente cancellazione
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-switch [(value)]="gridConf.allowDeleting"></dx-switch>
            </div>
          </div>
          @if (gridConf.allowDeleting) {
            <div class="dx-field">
              <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
                Controller custom per la cancellazione
              </div>
              <div class="dx-field-value" style="width: 30%">
                <dx-text-box [(value)]="gridConf.deletingController"></dx-text-box>
              </div>
            </div>
          }
          <!-- UPDATE MASSIVO -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              La griglia consente update massivo
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-switch [(value)]="gridConf.allowMassiveUpdate"></dx-switch>
            </div>
          </div>
          <!-- DELETE MASSIVO -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              La griglia consente delete massivo
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-switch [(value)]="gridConf.allowMassiveDelete"></dx-switch>
            </div>
          </div>
          @if (gridConf.allowMassiveDelete) {
            <div class="dx-field">
              <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
                Controller custom per delete massivo
              </div>
              <div class="dx-field-value" style="width: 30%">
                <dx-text-box [(value)]="gridConf.deletingController"></dx-text-box>
              </div>
            </div>
          }
          <!-- MERGE -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              La griglia consente il merge
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-switch [(value)]="gridConf.allowMerge"></dx-switch>
            </div>
          </div>
          <br />
        </div>
      }
      @if (gridConf.allowMerge) {
        <div class="dx-field">
          <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
            Menu custom per il merge
          </div>
          <div class="dx-field-value" style="width: 30%">
            <dx-text-box [(value)]="gridConf.mergeCustomMenu"></dx-text-box>
          </div>
        </div>
      }

      <!-- CONFRONTO -->
      @if (gridConf.editType && gridConf.editType != 'navigazione') {
        <div
          class="dx-field"
          >
          <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
            La griglia consente il confronto
          </div>
          <div class="dx-field-value" style="width: 30%">
            <dx-switch [(value)]="gridConf.allowComparison"></dx-switch>
          </div>
        </div>
      }
      <!-- SP ID -->
      @if (gridConf.editType && gridConf.editType != 'navigazione') {
        <div
          class="dx-field"
          >
          <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
            Possiede SP per Id selezionati
          </div>
          <div class="dx-field-value" style="width: 30%">
            <dx-switch [(value)]="gridConf.allowIdsSP"></dx-switch>
          </div>
        </div>
      }

      @if (gridConf.allowIdsSP) {
        <div class="dx-field">
          <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
            SP per ids
          </div>
          <div class="dx-field-value" style="width: 30%">
            <dx-text-box [(value)]="gridConf.idsSP"></dx-text-box>
          </div>
        </div>
      }
      @if (gridConf.allowIdsSP) {
        <div class="dx-field">
          <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
            Nome azione per SP ids
          </div>
          <div class="dx-field-value" style="width: 30%">
            <dx-text-box [(value)]="gridConf.idsSPActionName"></dx-text-box>
          </div>
        </div>
      }
      <br />
      @if (gridConf.editType === 'popup') {
        <div>
          <!-- Nr Colonne maschera editing -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              Nr colonne maschera di editing
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-text-box [(value)]="gridConf.editPopupColCount"></dx-text-box>
            </div>
          </div>
          <!-- Titolo Area 1 -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              Titolo Area 1
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-text-box [(value)]="gridConf.editPopupArea1Title"></dx-text-box>
            </div>
          </div>
          <!-- Titolo Area 2 -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              Titolo Area 2
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-text-box [(value)]="gridConf.editPopupArea2Title"></dx-text-box>
            </div>
          </div>
          <!-- Larghezza Popup -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              Larghezza Popup
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-number-box [(value)]="gridConf.editPopupWidth"></dx-number-box>
            </div>
          </div>
          <!-- Altezza Popup -->
          <div class="dx-field">
            <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
              Altezza Popup
            </div>
            <div class="dx-field-value" style="width: 30%">
              <dx-number-box [(value)]="gridConf.editPopupHeight"></dx-number-box>
            </div>
          </div>
          <!-- Griglia colonne Area 1-->
          <div class="dx-field">
            <div class="grid-container">
              <dx-data-grid
                id="gridConfig3"
                [dataSource]="gridConf.cols"
                [showBorders]="true"
                [rowAlternationEnabled]="true"
                [hoverStateEnabled]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                (onRowUpdated)="onConfigRowUpdating($event)"
                >
                <dxi-column
                  [allowEditing]="false"
                  dataField="dataField"
                  [caption]="'Id' | siaTranslate"
                  [width]="150"
                ></dxi-column>
                <dxi-column
                  dataField="caption"
                  [caption]="'Nome' | siaTranslate"
                ></dxi-column>
                <dxi-column
                  dataField="inDetailVisible"
                  [caption]="'Visibile' | siaTranslate"
                  dataType="boolean"
                ></dxi-column>
                <dxi-column
                  dataField="inDetailArea"
                  [caption]="'Area Appartenenza' | siaTranslate"
                  dataType="number"
                ></dxi-column>
                <dxi-column
                  dataField="inDetailColSpan"
                  [caption]="'ColSpan' | siaTranslate"
                  dataType="number"
                ></dxi-column>
                <dxi-column
                  dataField="inDetailSequence"
                  [caption]="'Ordinamento' | siaTranslate"
                  dataType="number"
                ></dxi-column>
                <dxi-column
                  dataField="inDetailEditorType"
                  [caption]="'Tipo Editor' | siaTranslate"
                  >
                  <dxo-lookup
                    [dataSource]="gridConfDetailEditorType"
                    displayExpr="name"
                    valueExpr="id"
                    >
                  </dxo-lookup>
                </dxi-column>
                <dxi-column
                  dataField="inDetailEditorOptions"
                  [caption]="'Opzioni Editor' | siaTranslate"
                ></dxi-column>
                <dxo-editing
                  mode="batch"
                  [allowUpdating]="true"
                  [selectTextOnEditStart]="selectTextOnEditStart"
                  [startEditAction]="startEditAction"
                  >
                </dxo-editing>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-remote-operations [sorting]="true" [paging]="true">
                </dxo-remote-operations>
                <dxo-sorting mode="multiple"></dxo-sorting>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                <dxo-load-panel [enabled]="false"></dxo-load-panel>
                <dxo-header-filter [visible]="false"></dxo-header-filter>
                <dxo-filter-row [visible]="false"></dxo-filter-row>
                <dxo-search-panel [visible]="false"></dxo-search-panel>
                <dxo-group-panel [visible]="false"></dxo-group-panel>
                <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
                <dxo-scrolling mode="virtual"></dxo-scrolling>
              </dx-data-grid>
            </div>
          </div>
        </div>
      }
      @if (gridConf.editType === 'navigazione') {
        <div>
          <div class="dx-fieldset" style="margin: 0px">
            <div class="dx-field">
              <div
                class="dx-field-label sia-conf-content"
                style="width: 70%"
                appI18n
                >
                Titolo
              </div>
              <div class="dx-field-value" style="width: 30%">
                <dx-text-box [(value)]="title"></dx-text-box>
              </div>
            </div>
          </div>
          <dx-data-grid
            id="gridConfigChoices"
            [dataSource]="getChoices()"
            [showBorders]="true"
            [rowAlternationEnabled]="true"
            [hoverStateEnabled]="true"
            [showColumnLines]="true"
            [showRowLines]="true"
            (onRowUpdated)="onConfigRowUpdating($event)"
            >
            <dxi-column
              dataField="icon"
              [caption]="'Icona' | siaTranslate"
              [width]="150"
              >
            </dxi-column>
            <dxi-column
              dataField="name"
              [caption]="'Nome' | siaTranslate"
              [width]="250"
              >
            </dxi-column>
            <dxi-column
              dataField="navigationMenu"
              [caption]="'Menu Navigazione' | siaTranslate"
              >
            </dxi-column>
            <dxo-editing
              mode="row"
              [allowUpdating]="true"
              [allowDeleting]="true"
              [allowAdding]="true"
              [selectTextOnEditStart]="selectTextOnEditStart"
              [startEditAction]="startEditAction"
              >
            </dxo-editing>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-remote-operations [sorting]="true" [paging]="true">
            </dxo-remote-operations>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
            <dxo-load-panel [enabled]="false"></dxo-load-panel>
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-search-panel [visible]="false"></dxo-search-panel>
            <dxo-group-panel [visible]="false"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
          </dx-data-grid>
        </div>
      }
    </div>
    @if (gridConf.editType == 'external page') {
      <div
        id="gridConfigValidationDiv"
        class="grid-container"
        >
        <!--Testata configurazione colonne-->
        <dx-data-grid
          id="gridConfigDetails"
          [dataSource]="gridConf.editParams"
          [showBorders]="true"
          [rowAlternationEnabled]="true"
          [hoverStateEnabled]="true"
          [showColumnLines]="true"
          [showRowLines]="true"
          (onRowUpdated)="onConfigRowUpdating($event)"
          >
          <dxi-column
            dataField="id"
            [caption]="'Nome valore' | siaTranslate"
            [width]="150"
            >
          </dxi-column>
          <dxi-column dataField="pattern" [caption]="'Pattern' | siaTranslate">
            <dxo-lookup
              [dataSource]="gridConfPatternsTypes"
              displayExpr="name"
              valueExpr="id"
              >
            </dxo-lookup>
          </dxi-column>
          <dxi-column dataField="value" [caption]="'Valore' | siaTranslate">
          </dxi-column>
          <dxo-editing
            mode="row"
            [allowUpdating]="true"
            [allowDeleting]="true"
            [allowAdding]="true"
            [selectTextOnEditStart]="selectTextOnEditStart"
            [startEditAction]="startEditAction"
            >
            </dxo-editing
            >s
            <dxo-selection mode="single"></dxo-selection>
            <dxo-remote-operations [sorting]="true" [paging]="true">
            </dxo-remote-operations>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
            <dxo-load-panel [enabled]="false"></dxo-load-panel>
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-search-panel [visible]="false"></dxo-search-panel>
            <dxo-group-panel [visible]="false"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
          </dx-data-grid>
        </div>
      }
    </div>
